export const distributeWay: {[key:string]: string} = {
  nokina: '軒並み',
  syuugo: '集合住宅',
  kodate: '戸建て'
}
